import { List } from './List'

export class SpecialityParent extends List {
  constructor(obj) {
    super(Speciality, obj)
  }
}

export class Speciality {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.scientificHeadName1 = obj?.scientificHeadName1 || null
    this.scientificHeadName2 = obj?.scientificHeadName2 || null
    this.speciality = obj?.speciality || null
  }

  getForAPI() {
    return {
      id: this.id,
      scientificHeadName1: this.scientificHeadName1,
      scientificHeadName2: this.scientificHeadName2,
      speciality: this.speciality
    }
  }
}
